import * as React from "react";
import type { SVGProps } from "react";
const SvgOrderIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="order_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M682.667 64H341.333A213.333 213.333 0 0 0 128 277.333v469.334A213.333 213.333 0 0 0 341.333 960h341.334A213.333 213.333 0 0 0 896 746.667V277.333A213.333 213.333 0 0 0 682.667 64zM213.333 277.333a128 128 0 0 1 128-128h341.334a128 128 0 0 1 128 128v469.334a128 128 0 0 1-128 128H341.333a128 128 0 0 1-128-128V277.333zm128 21.334a42.667 42.667 0 0 0 0 85.333h341.334a42.667 42.667 0 1 0 0-85.333H341.333zm0 170.666a42.667 42.667 0 1 0 0 85.334h341.334a42.667 42.667 0 1 0 0-85.334H341.333zm-42.666 213.334A42.667 42.667 0 0 1 341.333 640h256a42.667 42.667 0 1 1 0 85.333h-256a42.667 42.667 0 0 1-42.666-42.666z"
    />
  </svg>
);
export default SvgOrderIcon;
